import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable()
export class PessoaExpostaService extends BaseService {
  getStatementPaginated(filter: any) {
    let url = environment.portalApi + '/Statement/exposedPersonHistory?' + this.paramsToQueryString(filter);
    return this.http.get(url, { headers: this.createHeader() });
  }
  getLastStatement() {
    let url = environment.portalApi + '/Statement/lastExposedPerson';
    return this.http.get(url, { headers: this.createHeader() });
  }
  getPositions() {
    let url = environment.portalApi + '/Statement/exposedPersonPositions';
    return this.http.get(url, { headers: this.createHeader() });
  }
  postStatement(statement: any) {
    let url = environment.portalApi + '/Statement';
    return this.http.post(url, statement, { headers: this.createHeader() });
  }
  getStatementPdf(code: any) {
    let url = environment.portalApi + '/Statement/ExposedPersonPdf/' + code;
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
}
